import { useEffect, useState } from "react";
import { fromUrlExcursionVendor } from "../../../helper/vendorMask";
import { useLocation } from "react-router-dom";
import { getUserToken } from "../../../helper/commonFunction";
import { ApiCall } from "../../../helper/axios";

export const useCheckout = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState({
    withFare: false,
    withoutFare: false,
  });

  const bookingId = query.get("bId");
  const bookingVendor = fromUrlExcursionVendor(query.get("vendor")) === "rayna" ? "rayna" : "";

  const refresh = async () => {
    try {
      if (!bookingId) {
        return;
      }
      setLoading(true);

      const details = await ApiCall(
        "POST",
        `/excursions/booking-detail`,
        { vendor: bookingVendor, bookingId: String(bookingId) },
        {}
      );
      const body = details?.data;
      setData(body?.statusCode && body?.data ? body.data : body);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, [bookingId, bookingVendor]);

  const downloadPDF = async (fare) => {
    try {
      setPdfLoading({
        ...pdfLoading,
        [fare]: true
      })
      const userToken = getUserToken();

      const ticketName = 'excursion-booking.pdf';

      const res = await ApiCall(
        "POST",
        `excursionDownloadPdf`,
        { "userToken": userToken, "BookingId": bookingId, responseType: 'blob', withFare: fare === 'withFare' },
        {
          // responseType: 'blob',
        },
        "excursion"
      );
      if (res?.status === 200) {
        const blob = new Blob([res?.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', ticketName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error)
    } finally {
      setPdfLoading({
        ...pdfLoading,
        [fare]: false
      })
    }
  }
  return {
    bookingId,
    data,
    loading,
    downloadPDF,
    pdfLoading,
  };
};
